import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { HandleError, HttpErrorHandler } from '../../../util/http-error-handler.service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Usuario } from '../../../models/usuario/usuario';
import { Produto } from '../../../models/produto/produto';

const API_URL = environment.apiUrl;
const API_URL_BASE = environment.apiBaseUrl;


@Injectable({
  providedIn: 'root'
})
export class ConfiguracaoCartaoService {
  private handleError: HandleError;

  constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler) {
    this.handleError = httpErrorHandler.createHandleError('ConfiguracaoCartaoService');
  }

  obterTodos(param: any, direcao: string, propriedade: string): Observable<any> {
    const params = new HttpParams()
      .set('Direcao', `${(direcao)}`)
      .set('Propriedade', `${(propriedade)}`)
      .set('page', `${param.offset}`)
      .set('pageSize', `${param.limit}`)
      .set('descricao', `${param.descricao}`)
      .set('state', `${(param.state == true ? 1 : 0)}`);
    return this.http.get<any>(API_URL_BASE + "v2/cards", { params })
      .pipe(
        catchError(this.handleError('obterTodos', []))
      );
  }


  listarCartoes(): Observable<any> {
    return this.http.get<any>(API_URL_BASE + '/fidel/cards/list')
      .pipe(
        catchError(this.handleError('listarCartoes', []))
      );
  }

  listarUsuarios(): Observable<any> {
    return this.http.get<any>(API_URL_BASE + '/fidel/scorecustomer/listUsersScoredNotPaged')
      .pipe(
        catchError(this.handleError('listarUsuarios', []))
      );
  }
  listarUsuariosPontuadosDodia(): Observable<any> {
    return this.http.get<any>(API_URL_BASE + '/fidel/scorecustomer/listUsersScoredDayNotPaged')
      .pipe(
        catchError(this.handleError('listUsersScoredDayNotPaged', []))
      );
  }

  consultarUsuario(id, numero): Observable<any> {
    return this.http.get<any>(API_URL_BASE + `/fidel/scorecustomer/user?id=${id}&numero=${numero}`)
      .pipe(
        catchError(this.handleError('listarCartoes', []))
      );
  }

  cadastrarCartao(record: any): Observable<any> {
    return this.http.post<any>(API_URL_BASE + "v1/cards", record)
      .pipe(
        catchError(this.handleError('cadastrarCartao', record))
      );
  }
  atualizarCartao(record: any): Observable<any> {
    return this.http.put<any>(API_URL_BASE + "v1/cards", record)
      .pipe(
        catchError(this.handleError('atualizarCartao', record))
      );
  }
  inativarCartao(id: any): Observable<any> {
    return this.http.delete<any>(API_URL_BASE + `v1/cards/${id}`)
      .pipe(
        catchError(this.handleError('inativarCartao', id))
      );
  }

  editarCartao(id: any): Observable<any> {
    return this.http.get<any>(API_URL_BASE + `v1/cards/${id}`)
      .pipe(
        catchError(this.handleError('inativarCartao', id))
      );
  }

  pontuarCliente(record: any): Observable<any> {
    ///fidel/scorecustomer/registerpoint
    return this.http.post<Produto>(API_URL_BASE + 'v1/scorecustomer/registerpoint', record)
      .pipe(
        catchError(this.handleError('pontuarCliente', record))
      );
  }

  cadastrarEPontuar(record: any): Observable<any> {
    ///fidel/scorecustomer/registerpoint
    return this.http.post<Produto>(API_URL_BASE + 'v1/scorecustomer/registerUserAndRegisterPoint', record)
      .pipe(
        catchError(this.handleError('cadastrarEPontuar', record))
      );
  }

  marcarCartaoCompleto(record: any): Observable<any> {
    ///fidel/scorecustomer/registerpoint
    return this.http.post<Produto>(API_URL_BASE + 'v1/scorecustomer/markCardForComplete', record)
      .pipe(
        catchError(this.handleError('marcarCartaoCompleto', record))
      );
  }

}
